<div class="feed-container">

</div>
<app-showtime-overlay-locked class="overlay-locked" [lang]="lang" *ngIf="showLocked()" [gc]="gc"></app-showtime-overlay-locked>
<app-showtime-overlay-revealed class="overlay-revealed" [lang]="lang" *ngIf="showRevealed()" [gc]="gc"></app-showtime-overlay-revealed>
<app-showtime-overlay-playing class="overlay-playing" [logoUrl]="gm?.branding?.logoCornerUrl" [lang]="lang" *ngIf="showPlaying()"></app-showtime-overlay-playing>
<app-showtime-overlay-leaderboard class="overlay-leaderboard" [lang]="lang" [gm]="gm" *ngIf="showLeaderboard()"></app-showtime-overlay-leaderboard>
